<template>
  <div class="d-none d-sm-flex flex-column p-0 h-100">
    <div
      class="row d-flex flex-row align-items-center p-4 m-0 w-100"
      id="navbar"
    >
      <div class="d-flex flex-column">
        <h2 class="section-title">
          Activity Completed!
        </h2>
      </div>
    </div>

    <div
      ref="contentBody"
      class="d-flex flex-column p-4 content-body text-center"
    >
      <h2 class="font-rounded mb-5">
        You have completed all your activities!
      </h2>

      <p align="center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/PBZivp85eqI?loop=1&controls=0&autoplay=1&playlist=PBZivp85eqI"
          allow="autoplay;"
        >
        </iframe>
      </p>

      <p>
        <router-link class="btn btn-primary" to="/logout">
          Bye Bye!
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "assessment-done",
};
</script>
